import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16989 — one account from the tenant's QuickBooks Online chart of accounts.
 *
 * QuickBooks owns these rows: the summary posting job reads the chart of
 * accounts nightly (and on demand from Settings) and upserts it here by
 * QuickBooks id, so the GL mapping drop-downs and the posting job never have to
 * call QuickBooks just to list accounts. An account that QuickBooks no longer
 * returns, or returns as inactive, is kept with isActive = false so a mapping
 * that still points at it can be reported by name instead of failing blindly.
 *
 * Not audited: a cache of another system's data has no business edit history.
 */
@Index('qbo_account_qbo_id_uq', ['qboId'], { unique: true })
@Entity('qbo_account', {}, { auditable: false })
export class QboAccountEntity extends BaseEntity {
	/** QuickBooks Account.Id */
	@Column('varchar', { name: 'qboId', length: 32 })
	public qboId!: string;

	/** QuickBooks Account.AcctNum, the GL code. Optional in QuickBooks. */
	@Column('varchar', { name: 'acctNum', length: 32, nullable: true })
	public acctNum!: string | null;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	/** QuickBooks Account.FullyQualifiedName (includes parent accounts). */
	@Column('varchar', { name: 'fullName', length: 512, nullable: true })
	public fullName!: string | null;

	/** QuickBooks Account.AccountType, e.g. "Bank", "Income". */
	@Column('varchar', { name: 'accountType', length: 64 })
	public accountType!: string;

	@Column('varchar', { name: 'accountSubType', length: 64, nullable: true })
	public accountSubType!: string | null;

	@Column({ type: 'boolean', name: 'isActive', width: 1, default: () => "'1'" })
	public isActive!: boolean;

	/** When this row was last confirmed against QuickBooks. */
	@Column('datetime', { name: 'syncedDate' })
	public syncedDate!: Date;
}
